import { API_CONFIG } from "../constants";

/**
 * Convert image URL to absolute URL using API base URL
 * Handles relative URLs and localhost URLs
 * 
 * @param photoUrl - The photo URL from the API (can be relative, absolute, or localhost)
 * @returns Normalized absolute URL or undefined if no URL provided
 */
export function normalizeImageUrl(photoUrl?: string): string | undefined {
  if (!photoUrl) {
    return undefined;
  }
  if (photoUrl.startsWith("http://") || photoUrl.startsWith("https://")) {
    if (photoUrl.includes("localhost") || photoUrl.includes("127.0.0.1")) {
      const baseUrl = API_CONFIG.BASE_URL.replace(/\/api\/v1\/?$/, "").replace(/\/$/, "");
      const urlPath = photoUrl.replace(/^https?:\/\/[^/]+/, "");
      return `${baseUrl}${urlPath}`;
    }
    return photoUrl;
  }

  const baseUrl = API_CONFIG.BASE_URL.replace(/\/api\/v1\/?$/, "").replace(/\/$/, "");
  const normalizedPath = photoUrl.startsWith("/") ? photoUrl : `/${photoUrl}`;
  return `${baseUrl}${normalizedPath}`;
}
